module.exports = __webpack_public_path__ + "media/images/mailer/logo-89d0a8c476761e068df79089a566a026.png";